import { gsap, ScrollTrigger, smoothScrollObj, Modal } from "../layout";

document.addEventListener('DOMContentLoaded', () => {
    // show modal success
    const contactForm = document.querySelector(".wpcf7");
    const contactThanksModal = document.querySelector('#contactThanksModal');
    var contactThanksModalBs = new Modal(contactThanksModal, { keyboard: false });
    contactForm.addEventListener('wpcf7mailsent', function (event) {
        contactThanksModalBs.show();
    });

    // ---=== tel input number and "+" is allowed ===---
    function setInputFilter(textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
            textbox.addEventListener(event, function(e) {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        });
    }
    // init setInputFilter
    setInputFilter(document.getElementById("inputPhone"), function(value) {
        return /^[ 0-9+]*$/.test(value); // Allow digits and '.' only, using a RegExp
    }, "Only number is allowed");
    setInputFilter(document.getElementById("inputName"), function(value) {
        return /^[ a-zA-Z]*$/.test(value); // Allow letters only, using a RegExp
    }, "Only text is allowed");

    // prevent enter on submit
    document.querySelector(".wpcf7-form").onkeypress = function(e) {
        var key = e.charCode || e.keyCode || 0;     
        if (key == 13) {
            e.preventDefault();
        }
    }
})